import {IFieldPresetValue} from './field-preset-value.interface';
import {IPreset} from './preset.interface';



export class EnvironmentPreset implements IPreset {
    constructor(private _name: string, private _presetFieldsValues: IFieldPresetValue[]) {

    }

    get name(): string {
        return this._name;
    }

    applyPreset(): void {
        this._presetFieldsValues.forEach(preset => {
            preset.field.setValue(preset.value);
        });
    }
}